export default __webpack_public_path__ + "static/media/piechart.631b5b10.svg";